import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';

const QuickSearchField = styled((props) => (
  <TextField
    {...props}
  />
))(({ theme }) => ({
  [theme.breakpoints.down('xs')]: {
    width: '100%',
  },
  margin: '0 12px 0 0',
  '& .MuiSvgIcon-root': {
    marginRight: '4px',
    color: '#5a5e73',
  },
  border: `1px solid rgba(0, 0, 0, 0.1)`,
  borderRadius: '6px',
  [theme.breakpoints.down('md')]: {
    minWidth: '14rem',
  },
  [theme.breakpoints.up('md')]: {
    minWidth: '17rem',
  },
  [theme.breakpoints.up('lg')]: {
    minWidth: '22rem',
  },
  '& .Mui-focused': {
    background: '#fff',
    borderRadius: '6px',
  },
  '& .MuiInput-underline:before': {
    padding: '4px',
    border: `0 !important`,
  },
  '& .MuiInput-underline:after': {
    border: `0 !important`,
  },
  '& .MuiInputBase-input-MuiInput-input': {
    fontSize: '.8rem !important',
  },
  '& .MuiInputBase-root-MuiInput-root:hover:not(.Mui-disabled):before': {
    background: '#fff',
  }
}));

const TableToolbar = (props) => {
  const {
    //  getScreeners, setLoading, setMarketCap, marketCap, isLoading, estimatedResults, conditions, ScreenerFilters, Presets,
    menu, tableName, manageColumns, saveScreener, download, results, pagination,
  } = props || {}
  // const [state, setState] = React.useState({
  //   bottom: false,
  //   right: false,
  // });

  // const toggleDrawer = (anchor, open) => (event) => {
  //   if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
  //     return;
  //   }

  //   setState({ ...state, [anchor]: open });
  // };

  // const list = (anchor) => (
  //   <Box
  //     sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
  //     role="presentation"
  //     onClick={toggleDrawer(anchor, false)}
  //     onKeyDown={toggleDrawer(anchor, false)}
  //   >
  //     test
  //   </Box>
  // );

  return (
    <>
      {/* <Divider sx={{ my: 1 }} /> */}
      <Box
        sx={{
          // mt: 2,
          mb: .7, pb: .7, px: 2,
          // justifyContent: 'space-between',
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
          borderBottom: '1px solid rgba(0,0,0,0.08)',
          // flexDirection: { md: 'row-reverse', sm: 'row-reverse', xs: 'row' },
          // mb: 3
        }}
      >
        <QuickSearchField
          variant="standard"
          value={props.value}
          onChange={props.onChange}
          placeholder="Search ticker or keyword"
          className="searchField"
          InputProps={{
            startAdornment: <SearchIcon fontSize="small" sx={{ ml: 1 }} />,
            endAdornment: (
              <IconButton
                title="Clear"
                aria-label="Clear"
                size="small"
                style={{ visibility: props.value ? 'visible' : 'hidden' }}
                onClick={props.clearSearch}
                sx={{ '& .MuiSvgIcon-fontSizeSmall': { marginRight: '0 !important' } }}
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            ),
          }}
          sx={{
            background: '#fff',
            '&.MuiTextField-root.searchField': {
              m: '0',
            },
            '& .MuiSvgIcon-root': {
              fontSize: '1.1rem',
            },
            '& .MuiInputBase-input::placeholder': {
              fontSize: '.84rem',
            },
            '& .MuiInputBase-input': {
              fontSize: '.84rem',
              padding: '7px'
            },
            position: props.searchPosAbsolute ? 'absolute' : '',
            top: props.searchPosAbsolute ? 13 : '',
            right: props.searchPosAbsolute ? 0 : ''
          }}
        />
        {manageColumns}
        {download}
        {pagination}
      </Box>
    </>
  );
}

TableToolbar.propTypes = {
  clearSearch: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default TableToolbar;
